<script setup lang="ts">
    import { useStory } from '~/composables/storyblok-proxy/useStory';
    import type { ISbStoryData, SbBlokData } from '@storyblok/js';

    const props = defineProps<{ storyId?: string | ISbStoryData<ModalContentStoryblok> }>();
    const story = ref<ISbStoryData<ModalContentStoryblok> | null>();

    if (typeof props.storyId === 'string') {
        const { data } = await useStory<ModalContentStoryblok>(
            props.storyId,
            {
                find_by: 'uuid'
            },
            {
                disableCountrySegment: true
            }
        );

        watch(
            data,
            (newData) => {
                story.value = newData;
            },
            { immediate: true }
        );
    } else {
        story.value = props.storyId;
    }

    useStoryblokBridgeRef(story);
</script>

<template>
    <template v-if="storyId && story">
        <StoryblokComponentWrapper
            v-for="entry in story.content.content"
            :key="entry._uid"
            :blok="entry as SbBlokData"
        />
    </template>
</template>
